const projects = [ // New projects go at the top ↑ ↑
    {
        img: "/assets/banners/qomit.png",
        h1: "Q/OMIT",
        p: "Q/OMIT is dedicated to enhancing focus, sleep, and recovery through innovative products. Their flagship item, the Q/OMIT strip.one, is an invisible nose strip designed to improve breathing and overall well-being by addressing nasal congestion.",
        time: "Freelance",
        tags: ["UX/UI Design", "Web Design", "E-Commerce", "Shopify"],
        linkTo: "/qomit",
    },
    {
        img: "/assets/banners/portfolioo.png",
        h1: "Portfolio",
        p: "I decided to add my own portfolio to the case studies because, let's be honest, designing for yourself is always the hardest. You're your most demanding client. 🥲😂 This project pushed me to clarify my identity as a designer, balance style with UX, and refine every detail until it felt just right.",
        time: "2025",
        tags: ["UX/UI Design", "Web Design", "Web Development", "React", "Portfolio"],
        linkTo: "/portfolio",
    },
    {
        img: "/assets/banners/kblabb.png",
        h1: "KB Lab",
        p: "K|B Lab is a photography studio specializing in wedding, travel, and fashion photography. With a focus on storytelling and artistry, they capture authentic moments that highlight love, adventure, and style, creating timeless, high-quality images that resonate and leave a lasting impression.",
        time: "Freelance",
        tags: ["UX/UI Design", "Web Design", "Portfolio", "Photography"],
        linkTo: "/kblab",
    },
    {
        img: "/assets/banners/studycreww.png",
        h1: "StudyCrew",
        p: "StudyCrew is creating an open-source learning platform to make education more accessible, collaborative, and engaging. By connecting students with resources and a supportive community, it empowers them to explore their passions and reach their full potential.",
        time: "2023-2024",
        tags: ["UX/UI Design", "Web Design" , "Application Design", "Education"],
        linkTo: "/studycrew",
    },
    {
        img: "/assets/banners/sob2024.png",
        h1: "SoB 2024",
        p: "Summer of Bitcoin is a global, online summer internship program focused on introducing university students to bitcoin open-source development and design. Students spend 12 weeks during the summer contributing to an open-source project, earn bitcoin as stipend and put their summer break to good use.",
        time: "2024",
        tags: ["UX/UI Design", "Application Design", "Crypto", "Web3"],
        linkTo: "/summer-of-bitcoin-2024",
    },
];

export default projects;
